const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'wxDAI',
        decimals: 1e18,
        address: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
    }
};
